export default __webpack_public_path__ + "903a5c4c943551bf7445bc297d816204.svg";